import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { onDlgCancelClick, onDlgOkClick } from 'src/store/Dialog';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { ButtonComponent } from './ButtonComponent';
import { PopupComponent } from './PopupComponent';

export const AlertDialogComponent: React.FC = () => {
  const { text, cancelText, okText, open, title } = useAppSelector(state => state.dialog);
  const dispatch = useAppDispatch();
  return (
    <div>
      <PopupComponent
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{text}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonComponent onClick={() => dispatch(onDlgOkClick())} className="grey-btn">
            {cancelText}
          </ButtonComponent>
          <ButtonComponent onClick={() => dispatch(onDlgCancelClick())} autoFocus>
            {okText}
          </ButtonComponent>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};
